import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-custom-names',
  templateUrl: './custom-names.component.html',
  styleUrls: ['./custom-names.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomNamesComponent {}
